// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

body{
  color: rgb(6, 105, 116);
}

.car{
  color: #f8f7f7
}
  
.speedometer-container {
  animation: glow 2s infinite alternate;
  box-shadow: 0 0 15px rgba(0, 255, 0, 0.8);
}

@keyframes glow {
  0% {
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.5);
  }
  100% {
    box-shadow: 0 0 20px rgba(0, 255, 0, 1);
  }
}
@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.marquee {
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  animation: marquee 10s linear infinite;
}

.blink {
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/views/admin/dashboard/index.css"],"names":[],"mappings":"AAAA;IACI;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;AAEF;EACE,uBAAuB;AACzB;;AAEA;EACE;AACF;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,uCAAuC;EACzC;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["@keyframes blink {\n    0% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\nbody{\n  color: rgb(6, 105, 116);\n}\n\n.car{\n  color: #f8f7f7\n}\n  \n.speedometer-container {\n  animation: glow 2s infinite alternate;\n  box-shadow: 0 0 15px rgba(0, 255, 0, 0.8);\n}\n\n@keyframes glow {\n  0% {\n    box-shadow: 0 0 10px rgba(0, 255, 0, 0.5);\n  }\n  100% {\n    box-shadow: 0 0 20px rgba(0, 255, 0, 1);\n  }\n}\n@keyframes marquee {\n  0% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.marquee {\n  overflow: hidden;\n  white-space: nowrap;\n  display: inline-block;\n  animation: marquee 10s linear infinite;\n}\n\n.blink {\n  animation: blink 1.5s infinite;\n}\n\n@keyframes blink {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
